import PropTypes from 'prop-types';

import { Abstrap } from '../..';

const propTypes = { ...Abstrap.propTypes, width: PropTypes.oneOf(['xs', 's', 'm', 'l', 'xl']) };

const defaultProps = {
    ...Abstrap.defaultProps,
    componentClass: 'div',
    width: 'm',
};

class ModalContent extends Abstrap {

    getClassNameSchema() {
        const {
            className,
            width,
        } = this.props;
        return [
            'c-modal__container',
            `c-modal__container--${width}`,
            className,
        ];
    }

}

ModalContent.propTypes = propTypes;

ModalContent.defaultProps = defaultProps;

export default ModalContent;
